/* S20: approved source section algorithms with bounded listeners and media lifecycle. */
(function(){'use strict';if(window.NarwalS20)return;const states=new Map(),factories={"template--17309586522293__ndev-dx3-cards-1-cards-1":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-cards-1-cards-1');
        const nodeList = $narwal.getNodeList(node);

        let offsetList = [];
        const initOffset = () => {
            offsetList = [];
            [].concat(nodeList.info).forEach(item => {
                offsetList.push({
                    node: item,
                    show: false,
                    height: item.offsetHeight / 3,
                    top: $narwal.getOffset(item).top
                });
            });
        };

        initOffset();
        $narwal.on('resize', initOffset);
        $narwal.on('scroll', ({ top }) => {
            offsetList.forEach(item => {
                if (!item.show && top + $narwal.screenHeight - item.height > item.top) {
                    item.show = true;
                    item.node.classList.add('show');
                } else if (item.show && top + $narwal.screenHeight - item.height <= item.top) {
                    item.show = false;
                    item.node.classList.remove('show');
                }
            });
        });
    }, 'template--17309586522293__ndev-dx3-cards-1', true);
},
"template--17309586522293__ndev-main-full-media-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-full-media-media');
        const nodeList = $narwal.getNodeList(node);
        let infoShow = false, isPlay = false;
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight / 2 - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        if (nodeList.videoReset) {
            listen(nodeList.videoPc,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoH5,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoReset,'click', function() {
                nodeList.videoReset.classList.remove('show');
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
            });
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                
                if (isPlay && nodeList.content.dataset.type === 'video') {
                    if ($narwal.isMobile) {
                        nodeList.videoH5.pause();
                    } else {
                        nodeList.videoPc.pause();
                    }
                    isPlay = false;
                }
                
                return false;
            }

            if (!isPlay && nodeList.content.dataset.type === 'video') {
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
                isPlay = true;
            }


            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.content.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.content.style.opacity = fps;

            if (!infoShow && top - infoHeight >= infoY - $narwal.screenHeight) {
                nodeList.info.classList.add('show');
                infoShow = true;
            } else if (infoShow && top - infoHeight < infoY - $narwal.screenHeight) {
                nodeList.info.classList.remove('show');
                infoShow = false;
            }
        });
    }, 'template--17309586522293__ndev-main-full-media', true);
},
"template--17309586522293__ndev-main-half-media-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-half-media-media');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }

            const mediaNode = $narwal.isMobile ? nodeList.mediaMb : nodeList.mediaPc;
            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            mediaNode.style.transform = `scale(${0.8 + fps * 0.2})`;
            mediaNode.style.opacity = fps;
        });
    }, 'template--17309586522293__ndev-main-half-media', true);
},
"template--17309586522293__ndev-main-full-media2-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-full-media2-media');
        const nodeList = $narwal.getNodeList(node);
        let infoShow = false, isPlay = false;
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight / 2 - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        if (nodeList.videoReset) {
            listen(nodeList.videoPc,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoH5,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoReset,'click', function() {
                nodeList.videoReset.classList.remove('show');
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
            });
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                
                if (isPlay && nodeList.content.dataset.type === 'video') {
                    if ($narwal.isMobile) {
                        nodeList.videoH5.pause();
                    } else {
                        nodeList.videoPc.pause();
                    }
                    isPlay = false;
                }
                
                return false;
            }

            if (!isPlay && nodeList.content.dataset.type === 'video') {
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
                isPlay = true;
            }


            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.content.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.content.style.opacity = fps;

            if (!infoShow && top - infoHeight >= infoY - $narwal.screenHeight) {
                nodeList.info.classList.add('show');
                infoShow = true;
            } else if (infoShow && top - infoHeight < infoY - $narwal.screenHeight) {
                nodeList.info.classList.remove('show');
                infoShow = false;
            }
        });
    }, 'template--17309586522293__ndev-main-full-media2', true);
},
"template--17309586522293__ndev-dx3-clean-slide-slide":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-clean-slide-slide');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        if (infoY > offsetY + $narwal.screenHeight / 2) {
            infoY = offsetY + $narwal.screenHeight / 2;
        }

        const progress = (top) => {
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height,
                pageY: Math.round((Math.max(0, Math.min(height - $narwal.screenHeight, top - offsetY)) / (Math.max(1, height - $narwal.screenHeight))) * 100)
            };
        };

        let isStopScroll = false;
        let stepNav;
        const initStepEvent = () => {
            let _timer = null;
            const selectStep = index => {
                if (matchMedia('(prefers-reduced-motion:reduce)').matches) return;
                offsetY = $narwal.getOffset(node).top;
                height = node.offsetHeight;
                isStopScroll = true;
                const mod = (height - $narwal.screenHeight) / 4;
                window.scrollTo(0, offsetY + mod * index + (index > 0 ? 10 : 0));
                stepSet(index + 1);
                clearTimeout(_timer);
                _timer = setTimeout(() => { isStopScroll = false; }, 500);
            };
            nodeList.step.forEach((item,index) => listen(item,'click',()=>selectStep(index)));
            stepNav = node.querySelector('.nwb-s20-step-selector') || document.createElement('div');
            stepNav.className='nwb-s20-step-selector';stepNav.setAttribute('role','tablist');stepNav.setAttribute('aria-label','Этапы уборки');
            stepNav.innerHTML='';
            ['Уборка','Моющее средство','DirtSense','Сушка'].forEach((label,index)=>{
                const button=document.createElement('button');button.type='button';button.textContent=label;button.dataset.step=String(index+1);button.setAttribute('role','tab');
                const panel=nodeList.imageMb[index];panel.id ||= node.id+'-stage-'+(index+1);button.setAttribute('aria-controls',panel.id);
                listen(button,'click',()=>selectStep(index));
                listen(button,'keydown',e=>{if(['ArrowLeft','ArrowRight','Home','End'].includes(e.key)){e.preventDefault();const next=e.key==='Home'?0:e.key==='End'?3:(index+(e.key==='ArrowRight'?1:3))%4;selectStep(next);stepNav.children[next].focus();}});
                stepNav.append(button);
            });
            node.querySelector('.clean-content').append(stepNav);
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
            if (infoY > offsetY + $narwal.screenHeight / 2) {
                infoY = offsetY + $narwal.screenHeight / 2;
            }
        });

        initStepEvent();

        const stepSet = (index) => {
            node.dataset.nwbStepIndex=String(index);
            stepNav?.querySelectorAll('button').forEach((button,i)=>{button.setAttribute('aria-selected',String(i+1===index));button.tabIndex=i+1===index?0:-1;});
            nodeList.step.forEach((item,i)=>{const staticCopy=matchMedia('(prefers-reduced-motion:reduce)').matches;item.tabIndex=$narwal.isMobile||staticCopy?-1:0;if($narwal.isMobile||staticCopy)item.removeAttribute('role');else item.setAttribute('role','button');item.setAttribute('aria-hidden',String($narwal.isMobile&&!matchMedia('(prefers-reduced-motion:reduce)').matches&&i+1!==index));});
            if ($narwal.isMobile) {
                nodeList.step.forEach((item, i) => {
                    if (i + 1 === index) {
                        item.classList.add('active');
                    } else {
                        item.classList.remove('active');
                    }
                });

                nodeList.bar.style.transform = `translate3d(0, -${(4 - index) / 4 * 100}%, 0)`;
            } else {
                nodeList.step.forEach((item, i) => {
                    if (i + 1 <= index) {
                        item.classList.add('active');
                        if (i + 1 === index) {
                            item.classList.add('light');
                        } else {
                            item.classList.remove('light');
                        }
                    } else {
                        item.classList.remove('active');
                        item.classList.remove('light');
                    }
                });
            }

            const imageNode = $narwal.isMobile ? nodeList.imageMb : nodeList.imagePc;
            imageNode.forEach((item, i) => {
                if (i + 1 === index) {
                    item.classList.add('show');
                } else {
                    item.classList.remove('show');
                }
            });
        };

        const stageMotion = matchMedia('(prefers-reduced-motion:reduce)');
        listen(stageMotion, 'change', () => stepSet(stageMotion.matches ? 1 : Number(node.dataset.nwbStepIndex) || 1));
        stepSet(1);

        $narwal.on('scroll', ({ top }) => {
            if (isStopScroll) {
                return false;
            }
            const { pageY, enter } = progress(top);
            if (!enter) {
                return false;
            }

            let index = 1;

            if (pageY >= 75) {
                index = 4;
            } else if (pageY >= 50) {
                index = 3;
            } else if (pageY >= 25) {
                index = 2;
            }

            stepSet(index);

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }
        });
    }, 'template--17309586522293__ndev-dx3-clean-slide', true);
},
"template--17309586522293__ndev-dx3-clean-compare-compare":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-clean-compare-compare');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height,
                bottom: Math.round((Math.max(0, Math.min(height, bCurrent - offsetY)) / height) * 100)
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }

            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.media.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.media.style.opacity = fps;
        });
    }, 'template--17309586522293__ndev-dx3-clean-compare', true);
},
"template--17309586522293__ndev-main-half-media2-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-half-media2-media');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }

            const mediaNode = $narwal.isMobile ? nodeList.mediaMb : nodeList.mediaPc;
            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            mediaNode.style.transform = `scale(${0.8 + fps * 0.2})`;
            mediaNode.style.opacity = fps;
        });
    }, 'template--17309586522293__ndev-main-half-media2', true);
},
"template--17309586522293__ndev-main-full-media3-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-full-media3-media');
        const nodeList = $narwal.getNodeList(node);
        let infoShow = false, isPlay = false;
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight / 2 - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        if (nodeList.videoReset) {
            listen(nodeList.videoPc,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoH5,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoReset,'click', function() {
                nodeList.videoReset.classList.remove('show');
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
            });
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                
                if (isPlay && nodeList.content.dataset.type === 'video') {
                    if ($narwal.isMobile) {
                        nodeList.videoH5.pause();
                    } else {
                        nodeList.videoPc.pause();
                    }
                    isPlay = false;
                }
                
                return false;
            }

            if (!isPlay && nodeList.content.dataset.type === 'video') {
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
                isPlay = true;
            }


            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.content.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.content.style.opacity = fps;

            if (!infoShow && top - infoHeight >= infoY - $narwal.screenHeight) {
                nodeList.info.classList.add('show');
                infoShow = true;
            } else if (infoShow && top - infoHeight < infoY - $narwal.screenHeight) {
                nodeList.info.classList.remove('show');
                infoShow = false;
            }
        });
    }, 'template--17309586522293__ndev-main-full-media3', true);
},
"template--17309586522293__ndev-main-full-media4-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-full-media4-media');
        const nodeList = $narwal.getNodeList(node);
        let infoShow = false, isPlay = false;
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight / 2 - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        if (nodeList.videoReset) {
            listen(nodeList.videoPc,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoH5,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoReset,'click', function() {
                nodeList.videoReset.classList.remove('show');
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
            });
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                
                return false;
            }

            if (!isPlay && nodeList.content.dataset.type === 'video') {
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
                isPlay = true;
            }


            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.content.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.content.style.opacity = fps;

            if (!infoShow && top - infoHeight >= infoY - $narwal.screenHeight) {
                nodeList.info.classList.add('show');
                infoShow = true;
            } else if (infoShow && top - infoHeight < infoY - $narwal.screenHeight) {
                nodeList.info.classList.remove('show');
                infoShow = false;
            }
        });
    }, 'template--17309586522293__ndev-main-full-media4', true);
},
"template--17309586522293__ndev-dx3-clean-versatility-versatility":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-clean-versatility-versatility');
        const nodeList = $narwal.getNodeList(node);

        let offsetList = [];
        const initOffset = () => {
            offsetList = [];
            [].concat(nodeList.info).forEach(item => {
                offsetList.push({
                    node: item,
                    show: false,
                    top: $narwal.getOffset(item).top
                });
            });
        };

        initOffset();
        $narwal.on('resize', initOffset);
        $narwal.on('scroll', ({ top }) => {
            offsetList.forEach(item => {
                if (!item.show && top + $narwal.screenHeight - 200 > item.top) {
                    item.show = true;
                    item.node.classList.add('show');
                } else if (item.show && top + $narwal.screenHeight - 200 <= item.top) {
                    item.show = false;
                    item.node.classList.remove('show');
                }
            });
        });
    }, 'template--17309586522293__ndev-dx3-clean-versatility', true);
},
"template--17309586522293__ndev-main-full-media5-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-full-media5-media');
        const nodeList = $narwal.getNodeList(node);
        let infoShow = false, isPlay = false;
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight / 2 - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        if (nodeList.videoReset) {
            listen(nodeList.videoPc,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoH5,'ended', function() {
                nodeList.videoReset.classList.add('show');
            });
            listen(nodeList.videoReset,'click', function() {
                nodeList.videoReset.classList.remove('show');
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
            });
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                
                if (isPlay && nodeList.content.dataset.type === 'video') {
                    if ($narwal.isMobile) {
                        nodeList.videoH5.pause();
                    } else {
                        nodeList.videoPc.pause();
                    }
                    isPlay = false;
                }
                
                return false;
            }

            if (!isPlay && nodeList.content.dataset.type === 'video') {
                if ($narwal.isMobile) {
                    safePlay(nodeList.videoH5);
                } else {
                    safePlay(nodeList.videoPc);
                }
                isPlay = true;
            }


            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            nodeList.content.style.transform = `scale(${0.8 + fps * 0.2})`;
            nodeList.content.style.opacity = fps;

            if (!infoShow && top - infoHeight >= infoY - $narwal.screenHeight) {
                nodeList.info.classList.add('show');
                infoShow = true;
            } else if (infoShow && top - infoHeight < infoY - $narwal.screenHeight) {
                nodeList.info.classList.remove('show');
                infoShow = false;
            }
        });
    }, 'template--17309586522293__ndev-main-full-media5', true);
},
"template--17309586522293__ndev-main-half-media3-media":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-main-half-media3-media');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        let cHeight = ($narwal.screenHeight - height) / 2 + height;
        const progress = (top) => {
            // 从底部上来
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= cHeight,
                bottom: Math.round((Math.max(0, Math.min(cHeight, bCurrent - offsetY)) / cHeight) * 100)
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            cHeight = ($narwal.screenHeight - height) / 2 + height;
        });
        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }

            const mediaNode = $narwal.isMobile ? nodeList.mediaMb : nodeList.mediaPc;
            const fps = Math.max(0, Math.min(1, (bottom - 10) / 90));
            mediaNode.style.transform = `scale(${0.8 + fps * 0.2})`;
            mediaNode.style.opacity = fps;
        });
    }, 'template--17309586522293__ndev-main-half-media3', true);
},
"template--17309586522293__ndev-dx3-nimble-slide-slide":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-nimble-slide-slide');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        if (infoY > offsetY + $narwal.screenHeight / 2) {
            infoY = offsetY + $narwal.screenHeight / 2;
        }

        const progress = (top) => {
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height,
                pageY: Math.round((Math.max(0, Math.min(height - $narwal.screenHeight, top - offsetY)) / (Math.max(1, height - $narwal.screenHeight))) * 100)
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
            if (infoY > offsetY + $narwal.screenHeight / 2) {
                infoY = offsetY + $narwal.screenHeight / 2;
            }
        });

        const mbImageList = [];
        nodeList.imageMb.forEach(item => {
            mbImageList.push(item.getAttribute('data-src') || item.getAttribute('src'));
        });
        const pcImageList = [];
        nodeList.image.forEach(item => {
            pcImageList.push(item.getAttribute('data-src') || item.getAttribute('src'));
        });

        const stepSet = (index) => {
            if ($narwal.isMobile) {
                nodeList.imageMb[0].src = mbImageList[index - 1];
                // nodeList.imageMb.forEach((item, i) => {
                //     if (i + 1 === index) {
                //         item.classList.add('show');
                //     } else {
                //         item.classList.remove('show');
                //     }
                // });
            } else {
                nodeList.image[0].src = pcImageList[index - 1];
                // nodeList.image.forEach((item, i) => {
                //     if (i + 1 === index) {
                //         item.classList.add('show');
                //     } else {
                //         item.classList.remove('show');
                //     }
                // });
            }
        };

        $narwal.on('scroll', ({ top }) => {
            const { pageY, enter } = progress(top);
            if (!enter) {
                return false;
            }

            let index = 1;

            if (pageY >= 75) {
                index = 4;
            } else if (pageY >= 50) {
                index = 3;
            } else if (pageY >= 25) {
                index = 2;
            }

            stepSet(index);

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }
        });
    }, 'template--17309586522293__ndev-dx3-nimble-slide', true);
},
"template--17309586522293__ndev-dx3-cards-2-cards-2":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-cards-2-cards-2');
        const nodeList = $narwal.getNodeList(node);

        let offsetList = [];
        const initOffset = () => {
            offsetList = [];
            [].concat(nodeList.info).forEach(item => {
                offsetList.push({
                    node: item,
                    show: false,
                    height: item.offsetHeight / 3,
                    top: $narwal.getOffset(item).top
                });
            });
        };

        initOffset();
        $narwal.on('resize', initOffset);
        $narwal.on('scroll', ({ top }) => {
            offsetList.forEach(item => {
                if (!item.show && top + $narwal.screenHeight - item.height > item.top) {
                    item.show = true;
                    item.node.classList.add('show');
                } else if (item.show && top + $narwal.screenHeight - item.height <= item.top) {
                    item.show = false;
                    item.node.classList.remove('show');
                }
            });
        });
    }, 'template--17309586522293__ndev-dx3-cards-2', true);
},
"template--17309586522293__ndev-dx3-match-match":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-match-match');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = nodeList.info.offsetHeight;
        let infoY = $narwal.getOffset(nodeList.info).top;
        const progress = (top) => {
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height
            };
        };

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
        });
        $narwal.on('scroll', ({ top }) => {
            const { enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }
        });
    }, 'template--17309586522293__ndev-dx3-match', true);
},
"template--17309586522293__ndev-dx3-inside-outside-outside":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-inside-outside-outside');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;

        const progress = (top) => {
            const bCurrent = top + $narwal.screenHeight;
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height,
                bottom: Math.round((Math.max(0, Math.min(height, bCurrent - offsetY)) / height) * 100),
                pageY: Math.round((Math.max(0, Math.min(height - $narwal.screenHeight, top - offsetY)) / (Math.max(1, height - $narwal.screenHeight))) * 100)
            };
        };

        let swiper = null;
        const initSwipe = () => {
            const sizes = Number(nodeList.swipe.dataset.size);
            swiper = createSwiper(nodeList.swipe, {
                slidesPerView: 1.13,
                spaceBetween: 0,
                loop: true,
                autoplay: true,
                on: {
                    slideChangeTransitionEnd: function() {
                        const activeIndex = this.realIndex;
                        nodeList.bar.style.transform = `translate3d(-${(sizes - 1 - activeIndex) / sizes * 100}%, 0, 0)`;
                    }
                }
            });
        };

        if ($narwal.isMobile) {
            initSwipe();
        }

        $narwal.on('resize', () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            if ($narwal.isMobile) {
                if (!swiper) {
                    initSwipe();
                }
                swiper.updateSize();
            }
        });

        $narwal.on('scroll', ({ top }) => {
            const { bottom, enter } = progress(top);
            if (!enter) {
                return false;
            }

            const isActive = nodeList.content.classList.contains('active');
            if (bottom >= 50 && !isActive) {
                nodeList.content.classList.add('active');
                nodeList.info.classList.remove('hidden');
                nodeList.info.classList.add('show');
            } else if (bottom < 50 && isActive) {
                nodeList.content.classList.remove('active');
                nodeList.info.classList.remove('show');
                nodeList.info.classList.add('hidden');
            }
        });
    }, 'template--17309586522293__ndev-dx3-inside-outside', true);
},
"template--17309586522293__ndev-dx3-all-parts-parts":function($narwal,listen,safePlay,createSwiper){
    $narwal.designMode(() => {
        const node = document.getElementById('template--17309586522293__ndev-dx3-all-parts-parts');
        const nodeList = $narwal.getNodeList(node);
        let offsetY = $narwal.getOffset(node).top;
        let height = node.offsetHeight;
        let infoHeight = 0;
        let infoY = 0;
        const progress = (top) => {
            return {
                enter: top + $narwal.screenHeight - offsetY >= 0 && top + $narwal.screenHeight - offsetY - 50 <= height
            };
        };

        const initData = () => {
            offsetY = $narwal.getOffset(node).top;
            height = node.offsetHeight;
            infoHeight = nodeList.info.offsetHeight;
            infoY = $narwal.getOffset(nodeList.info).top;
        };

        $narwal.on('resize', initData);
        $narwal.on('scroll', ({ top }) => {
            const { enter } = progress(top);
            if (!enter) {
                return false;
            }

            if (infoY === 0) {
                initData();
            }

            const isShow = nodeList.info.classList.contains('show');
            if (top - infoHeight >= infoY - $narwal.screenHeight && !isShow) {
                nodeList.info.classList.add('show');
            } else if (top - infoHeight < infoY - $narwal.screenHeight && isShow) {
                nodeList.info.classList.remove('show');
            }
        });
    }, 'template--17309586522293__ndev-dx3-all-parts', true);
}};const reduce=matchMedia('(prefers-reduced-motion:reduce)');window.NarwalS20={states,errors:[],motion:reduce};
function attach(root,factory){if(states.has(root)||typeof $narwal==='undefined')return;const abort=new AbortController(),scroll=[],resize=[],swipers=[],timers=[];let frame=0;const listen=(node,event,fn)=>{if(node)node.addEventListener(event,fn,{signal:abort.signal,passive:event==='scroll'});};const helper={getNodeList:$narwal.getNodeList,getOffset:$narwal.getOffset,get screenHeight(){return innerHeight;},get screenWidth(){return innerWidth;},get isMobile(){return innerWidth<=768;},designMode(fn){fn();},on(event,fn){if(event==='scroll')scroll.push(fn);else if(event==='resize')resize.push(fn);else if(event==='DOMContentLoaded')fn();}};
function syncMedia(){root.querySelectorAll('video').forEach(video=>{const box=video.getBoundingClientRect();if((reduce.matches&&!video.__nwbUserStarted)||video.__nwbUserPaused||!video.getClientRects().length||box.bottom<=0||box.top>=innerHeight)video.pause();else if(video.paused&&!video.__nwbStarting)safePlay(video);});swipers.forEach(s=>{if(!s.__nwbAuto||s.destroyed)return;const rect=s.el.getBoundingClientRect();const play=!reduce.matches&&!s.__nwbPaused&&rect.bottom>0&&rect.top<innerHeight&&!s.el.matches(':hover')&&!s.el.contains(document.activeElement);if(play)s.autoplay?.start();else s.autoplay?.stop();});}
function safePlay(video){if(!video)return Promise.resolve();const box=video.getBoundingClientRect();if((reduce.matches&&!video.__nwbUserStarted)||!video.getClientRects().length||box.bottom<=0||box.top>=innerHeight)return Promise.resolve();if(video.dataset.src&&!video.getAttribute('src')){video.src=video.dataset.src;video.load();}video.querySelectorAll('source[data-src]').forEach(source=>{if(!source.getAttribute('src')){source.src=source.dataset.src;video.load();}});video.muted=true;video.playsInline=true;video.__nwbStarting=true;return video.play().catch(()=>{}).finally(()=>{video.__nwbStarting=false;});}
function createSwiper(el,options){if(typeof Swiper==='undefined')return null;const auto=!!options.autoplay;options.speed=reduce.matches?0:300;if(auto)options.autoplay={delay:3000,disableOnInteraction:false};const s=new Swiper(el,options);s.__nwbAuto=auto;swipers.push(s);if(auto){const button=document.createElement('button');button.type='button';button.className='nwb-s20-autoplay-toggle';button.textContent=reduce.matches?'Воспроизвести карусель':'Приостановить карусель';button.setAttribute('aria-label',button.textContent);s.__nwbPaused=reduce.matches;el.append(button);listen(button,'click',()=>{s.__nwbPaused=!s.__nwbPaused;button.textContent=s.__nwbPaused?'Воспроизвести карусель':'Приостановить карусель';button.setAttribute('aria-label',button.textContent);if(!s.__nwbPaused)s.autoplay.start();else s.autoplay.stop();});listen(el,'keydown',e=>{if(e.target!==button&&['ArrowLeft','ArrowRight'].includes(e.key)){e.preventDefault();e.key==='ArrowLeft'?s.slidePrev():s.slideNext();}});el.tabIndex=0;el.setAttribute('aria-label','Карусель сведений о продукте S20');}return s;}
function tick(){frame=0;root.toggleAttribute('data-nwb-reduced',reduce.matches);if(!reduce.matches)scroll.forEach(fn=>{try{fn({top:scrollY,left:scrollX});}catch(error){window.NarwalS20.errors.push(error.message);}});syncMedia();}
function request(){if(!frame)frame=requestAnimationFrame(tick);}
function measure(){resize.forEach(fn=>{try{fn();}catch(error){window.NarwalS20.errors.push(error.message);}});request();}
try{factory(helper,listen,safePlay,createSwiper);root.setAttribute('data-nwb-s20-ready','');}catch(error){window.NarwalS20.errors.push(error.message);}
listen(window,'scroll',request);listen(window,'resize',measure);listen(window,'load',measure);listen(reduce,'change',()=>{root.querySelectorAll('video').forEach(v=>v.__nwbUserStarted=false);measure();});listen(root,'mouseenter',syncMedia);listen(root,'mouseleave',syncMedia);listen(root,'focusin',syncMedia);listen(root,'focusout',()=>timers.push(setTimeout(syncMedia,0)));root.querySelectorAll('img').forEach(img=>listen(img,'load',measure));listen(document,'visibilitychange',()=>{if(document.hidden){root.querySelectorAll('video').forEach(v=>v.pause());swipers.forEach(s=>s.autoplay?.stop());}else request();});
root.querySelectorAll('[node-name="step"],.video-reset-play').forEach(el=>{el.tabIndex=root.matches('.m-dx3-clean-slide')&&(helper.isMobile||reduce.matches)?-1:0;if(!(root.matches('.m-dx3-clean-slide')&&(helper.isMobile||reduce.matches)))el.setAttribute('role','button');if(el.classList.contains('video-reset-play'))el.setAttribute('aria-label','Повторить видео о продукте');listen(el,'keydown',e=>{if(e.key==='Enter'||e.key===' '){e.preventDefault();el.click();}});});
if(root.querySelector('video')){const button=document.createElement('button');button.type='button';button.className='nwb-s20-video-toggle';button.textContent='Воспроизвести видео';const holder=root.querySelector('[node-name="content"]')||root;holder.append(button);function caption(){const v=[...root.querySelectorAll('video')].find(v=>v.getClientRects().length);button.textContent=v&&!v.paused?'Приостановить видео':'Воспроизвести видео';button.setAttribute('aria-label',button.textContent);}listen(button,'click',()=>{const video=[...root.querySelectorAll('video')].find(v=>v.getClientRects().length);if(!video)return;if(video.paused){video.__nwbUserPaused=false;video.__nwbUserStarted=true;safePlay(video).catch(()=>{video.controls=true;});}else{video.__nwbUserPaused=true;video.pause();}caption();});root.querySelectorAll('video').forEach(v=>{listen(v,'play',caption);listen(v,'pause',caption);});caption();}
const observer=new IntersectionObserver(request,{rootMargin:'100%'});observer.observe(root);states.set(root,{destroy(){abort.abort();observer.disconnect();cancelAnimationFrame(frame);timers.forEach(clearTimeout);root.querySelector('.nwb-s20-step-selector')?.remove();swipers.forEach(s=>s.destroy(true,true));root.querySelectorAll('video').forEach(v=>v.pause());states.delete(root);}});measure();}
function frameScene(root){if(states.has(root))return;const canvas=root.querySelector('canvas'),ctx=canvas.getContext('2d'),poster=root.querySelector('.nwb-s20-frame-poster'),video=document.createElement('video'),abort=new AbortController();video.muted=true;video.playsInline=true;video.preload='auto';let mode='',desired=0,seeking=false,ready=false,raf=0,near=false;const on=(node,event,fn)=>node.addEventListener(event,fn,{signal:abort.signal});
function draw(){if(video.seeking||video.readyState<2)return;if(Math.abs(video.currentTime-desired)>.035){seeking=false;seek();return;}if(video.readyState>=2){canvas.width=video.videoWidth;canvas.height=video.videoHeight;ctx.drawImage(video,0,0);canvas.setAttribute('data-frame-time',video.currentTime.toFixed(3));poster.hidden=true;}seeking=false;if(Math.abs(video.currentTime-desired)>.018)seek();}
function seek(){if(video.readyState<1||video.seeking||reduce.matches||!near)return;if(Math.abs(video.currentTime-desired)<.018){if(video.readyState>=2)draw();return;}seeking=true;try{video.currentTime=Math.min(Math.max(0,video.duration-.025),desired);}catch(_){}}
function update(){raf=0;root.setAttribute('data-frame-updates',String(Number(root.getAttribute('data-frame-updates')||0)+1));const mobile=innerWidth<=768,next=mobile?'mb':'pc',rect=root.getBoundingClientRect(),height=root.offsetHeight;root.toggleAttribute('data-nwb-reduced',reduce.matches);if(mode!==next){mode=next;ready=false;seeking=false;poster.hidden=false;poster.src=root.dataset[mobile?'posterMb':'posterPc'];video.removeAttribute('src');video.load();}
if(reduce.matches){video.pause();poster.hidden=false;return;}if(near&&!video.getAttribute('src')){video.src=root.dataset[mobile?'framesMb':'framesPc'];video.load();}const progress=Math.round(Math.max(0,Math.min(1,(-rect.top+innerHeight*2/3)/Math.max(1,height-innerHeight)))*100),count=mobile?81:87,index=Math.min(Math.max(1,Math.floor((count+2)/95*progress)),count+2);desired=Math.min((count-1)/25,Math.max(0,(index-3)/25));root.setAttribute('data-frame-desired',desired.toFixed(3));const top=root.querySelector('[node-name="infoTop"]'),bottom=root.querySelector('[node-name="infoBottom"]');top.classList.toggle('show',index>=4);top.classList.toggle('hidden',index>=40);bottom.classList.toggle('show',index>=46);bottom.classList.toggle('slide',index>=70);seek();}
const request=()=>{if(!raf)raf=requestAnimationFrame(update);};on(video,'loadeddata',()=>{ready=true;seeking=false;seek();});on(video,'seeked',draw);on(video,'error',()=>{poster.hidden=false;root.setAttribute('data-nwb-media-failed','');});on(window,'scroll',request);on(window,'resize',request);on(reduce,'change',request);const observer=new IntersectionObserver(entries=>{near=entries[0].isIntersecting;request();},{rootMargin:'100%'});observer.observe(root);root.setAttribute('data-nwb-s20-ready','');states.set(root,{update,read(){return {ready:video.readyState,seeking:video.seeking,current:video.currentTime,desired,near,reduced:reduce.matches};},destroy(){abort.abort();observer.disconnect();cancelAnimationFrame(raf);video.removeAttribute('src');video.load();states.delete(root);}});update();}
function hero(root){if(states.has(root))return;const abort=new AbortController(),content=root.querySelector('[node-name="content"]'),videos=[...root.querySelectorAll('video')];let timeout;function reveal(){content?.classList.remove('hidden');}function sync(){const video=videos.find(v=>v.getClientRects().length);videos.filter(v=>v!==video).forEach(v=>v.pause());if(reduce.matches||!video){videos.forEach(v=>v.pause());reveal();return;}if(video.dataset.src&&!video.src)video.src=video.dataset.src;video.muted=true;video.play().then(()=>{clearTimeout(timeout);timeout=setTimeout(reveal,Math.min(10000,(video.duration||4)*1000));}).catch(reveal);}videos.forEach(v=>{v.addEventListener('ended',reveal,{signal:abort.signal});v.addEventListener('error',reveal,{signal:abort.signal});});window.addEventListener('resize',sync,{signal:abort.signal});reduce.addEventListener('change',sync,{signal:abort.signal});sync();timeout=setTimeout(reveal,6000);states.set(root,{destroy(){abort.abort();clearTimeout(timeout);videos.forEach(v=>v.pause());states.delete(root);}});}
reduce.addEventListener('change',()=>{for(const state of states.values())if(state.update)state.update();});
function scan(scope){for(const id of Object.keys(factories)){const root=scope.querySelector('#'+CSS.escape(id));if(root)attach(root,factories[id]);}const frame=scope.querySelector('[data-nwb-s20-frames]');if(frame)frameScene(frame);const banner=scope.querySelector('#ndev-main-banner-banner');if(banner)hero(banner);}
if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>scan(document),{once:true});else scan(document);document.addEventListener('shopify:section:load',e=>scan(e.target));document.addEventListener('shopify:section:unload',e=>{for(const[root,state]of states)if(e.target.contains(root))state.destroy();});
}());
